export const GET_PRE_AUTH = 'OTT/3DS_PRE_AUTH/GET_PRE_AUTH';
export const GET_PRE_AUTH_SUCCESS = 'OTT/3DS_PRE_AUTH/GET_PRE_AUTH_SUCCESS';
export const GET_PRE_AUTH_FAIL = 'OTT/3DS_PRE_AUTH/GET_PRE_AUTH_FAIL';
export const RESET = 'OTT/3DS_PRE_AUTH/RESET';
